module.exports = __webpack_public_path__ + "img/ambientacion1.bdc8bede.jpg";